import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

/**
 * رنگ آیکون هر کارت منو — کلید باید دقیقاً با فیلد `color` در Dashboard هم‌خوان باشد.
 * (گرادیان tailwind → یک رنگ پررنگ برای آیکن ant)
 */
const iconColors = {
  'from-indigo-500 to-indigo-600': '#6366f1',
  'from-blue-500 to-blue-600': '#3b82f6',
  'from-green-500 to-green-600': '#22c55e',
  'from-purple-500 to-purple-600': '#a855f7',
  'from-emerald-500 to-emerald-600': '#10b981',
  'from-sky-500 to-sky-600': '#0ea5e9',
  'from-yellow-500 to-yellow-600': '#eab308',
  'from-cyan-500 to-cyan-600': '#06b6d4',
  'from-orange-500 to-orange-600': '#f97316',
  'from-pink-500 to-pink-600': '#ec4899',
  'from-gray-500 to-gray-600': '#6b7280',
  'from-violet-500 to-indigo-600': '#7c3aed',
  'from-emerald-500 to-teal-600': '#14b8a6',
  'from-amber-500 to-orange-600': '#f59e0b',
  'from-indigo-500 to-violet-600': '#6366f1',
  'from-violet-500 to-fuchsia-600': '#c026d3',
  'from-sky-500 to-cyan-600': '#0891b2',
};

// کامپوننت نمایش آیکون‌های منو (مشابه Odoo)
// دسکتاپ: ۵ ستون | تبلت: ۴–۳ ستون | موبایل: ۲ ستون
const MenuIcons = ({ menuItems = [], onIconClick }) => {
  const { isDarkMode } = useTheme();

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-4 px-3 py-4 sm:p-6 max-w-6xl mx-auto w-full min-w-0">
      {menuItems.map((item, index) => {
        const iconColor = iconColors[item.color] || (isDarkMode ? '#9ca3af' : '#4b5563');

        return (
          <button
            key={index}
            onClick={() => onIconClick?.(item)}
            className={`
              flex flex-col items-center justify-center
              w-full min-h-[5.5rem] h-28 rounded-xl
              transition-all duration-300
              ${
                isDarkMode
                  ? 'bg-gray-800 hover:bg-gray-700 border border-gray-700'
                  : 'bg-white hover:bg-gray-50 border border-gray-200 shadow-sm'
              }
              hover:shadow-xl hover:scale-105 active:scale-[0.98]
              group
            `}
            style={{ fontFamily: 'CustomFont' }}
          >
            <div
              className="text-3xl sm:text-4xl mb-2 sm:mb-3 transition-transform group-hover:scale-110 flex-shrink-0"
              style={{
                color: iconColor,
              }}
            >
              {React.cloneElement(item.icon, {
                style: {
                  fontSize: 'clamp(1.75rem, 5vw, 2.5rem)',
                },
              })}
            </div>
            <span
              className={`
              text-xs sm:text-sm font-semibold text-center leading-tight px-1 break-words line-clamp-2
              ${isDarkMode ? 'text-gray-200' : 'text-gray-800'}
              transition-colors
            `}
            >
              {item.label}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default MenuIcons;
